import { Editor } from "@tiptap/core"

export const isMarkInSchema = (markName: string, editor: Editor): boolean => {
	return editor.schema.spec.marks.get(markName) !== undefined
}

export const isNodeInSchema = (nodeName: string, editor: Editor): boolean => {
	return editor.schema.spec.nodes.get(nodeName) !== undefined
}

export const isExtensionInManager = (extensionName: string, editor: Editor) => {
	return editor.extensionManager.extensions.some((extension) => extension.name === extensionName)
}
